<script>
import ModuleTitle from '../common/ModuleTitle.vue'

export default {
  name: 'Comp19',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  }
}
</script>

<template>
  <div class="modules-id-19">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-18-content pointer">
      <el-image
        v-for="v in moduleOption.list.slice(0, 1)"
        :key="`modules-19-${v.id}`"
        :src="v.photo | imgPath"
        alt="work"
        class="item-img"
        fit="cover"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-19-content {
  width: 100%;
  height: 100%;
  display: flex;
}
.item-img {
  width: 450px;
  height: 315px;
}
</style>
